import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { Project } from '../../model/project/project';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { RequestService } from '../../services/request.service';
import Employee from '../../model/product/employee';
import Quotation from '../../model/quotation';
import { SubProject } from '../../model/project/sub-project';
import ProjectHelper from '../../helpers/project-helper';
import { ProjectPlacement } from '../../model/project/projectPlacement';
import DateHelper from '../../helpers/date-helper';
import { BaseProject } from 'src/app/model/project/base-project';
import { SendQuotationMailComponent } from '../send-quotation-mail/send-quotation-mail.component';
import RegisteredAction from 'src/app/model/registered-action';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { SnackService } from 'src/app/services/snack.service';
import ProductAsset from 'src/app/model/product-asset';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { ModalService } from 'src/app/services/modal.service';
import { NotificationMailComponent } from '../notification-mail/notification-mail.component';
import { User } from 'src/app/model/user';
import { Adjustment } from 'src/app/model/project/adjustment';
import { NotificationMailRequestBody } from '../notification-mail/notification-mail-request-body';
import { ResetQuotationSentComponent } from '../reset-quotation-sent/reset-quotation-sent.component';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Subject } from 'rxjs';
import { cloneDeep } from 'lodash';
import { FileHelper } from '../../helpers/file-helper';

@Component({
  selector: 'app-quotation-sitevisit-pending',
  templateUrl: './quotation-sitevisit-pending.component.html',
  styleUrls: ['./quotation-sitevisit-pending.component.scss'],
})
export class QuotationSitevisitPendingComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  init = false;
  sending = false;
  performingResetAction = false;
  public quotationHandlerChoices: Employee[] = [];
  public siteVisitEmployeeChoices: Employee[] = [];
  public locationAssets: ProductAsset[] = [];

  @Input()
  subProjectId: number;

  @Input()
  inputProject: Project;

  @Input()
  loadProject: boolean;

  @Input()
  subProject: SubProject;

  @Input()
  setSubProjectSubject: Subject<SubProject>;

  @Input()
  setProjectSubject: Subject<Project>;

  oninitSent = false;
  quotationWasNull = false;
  private sendQuotationDialogRef: MatDialogRef<SendQuotationMailComponent>;
  private resetQuotationSentDialogRef: MatDialogRef<ResetQuotationSentComponent>;
  private notificationMailDialogRef: MatDialogRef<NotificationMailComponent>;
  isImage = FileHelper.isImage;

  constructor(
    public dialogRef: MatDialogRef<QuotationSitevisitPendingComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private sendQuotationDialog: MatDialog,
    private resetSendQuotationDialog: MatDialog,
    private notificationMailDialog: MatDialog,
    private requestService: RequestService,
    private snackService: SnackService,
    private modalService: ModalService
  ) {
    super();
    this.subProjectId = data.subProjectId;
    this.inputProject = data.project;
    this.loadProject = data.loadProject;
    this.subProject = data.subProject;
    this.setSubProjectSubject = data.setSubProjectSubject;
    this.setProjectSubject = data.setProjectSubject;
  }

  ngOnInit() {
    if (this.loadProject) {
      this.doLoadProject();
    } else {
      this.oninitSent = this.subProject.quotationSent;
      this.quotationWasNull = this.subProject.quotation == null;
      this.initLocationAssets();
    }
    this.getQuotationHandlers();
    this.getSiteVisitEmployees();
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  confirm() {
    this.dialogRef.close(this.inputProject);
  }

  setImportantPending() {
    if (this.subProject.pendingImportant != null) {
      this.subProject.pendingImportant = !this.subProject.pendingImportant;
    } else {
      this.subProject.pendingImportant = true;
    }
  }

  setPending(value) {
    this.subProject.pending = value;
  }

  setImportantQuotation() {
    if (this.subProject.quotationImportant != null) {
      this.subProject.quotationImportant = !this.subProject.quotationImportant;
    } else {
      this.subProject.quotationImportant = true;
    }
  }

  setQuotation(value) {
    this.subProject.needsQuotation = value;
    if (this.subProject.needsQuotation) {
      this.initQuotations();
    }
  }

  getQuotationHandlers() {
    this.addSubscription(
      this.requestService.get('/employees/withType/QUOTATION'),
      (result) => {
        this.quotationHandlerChoices = <Employee[]>result.body;
      }
    );
  }

  getSiteVisitEmployees() {
    this.addSubscription(
      this.requestService.get('/employees/withType/SITE_VISIT'),
      (result) => {
        const siteVisitEmployees = <Employee[]>result.body;
        if (
          siteVisitEmployees != null &&
          this.subProject.projectPlacement != null &&
          this.subProject.projectPlacement.employee != null &&
          !siteVisitEmployees.some(
            (e) => e.id === this.subProject.projectPlacement.employee.id
          )
        ) {
          const currentEmployeeClone = cloneDeep(
            this.subProject.projectPlacement.employee
          );
          siteVisitEmployees.push(currentEmployeeClone);
        }
        this.siteVisitEmployeeChoices = siteVisitEmployees;
        if (!this.loadProject) {
          this.init = true;
        }
      }
    );
  }

  doLoadProject() {
    this.addSubscription(
      this.requestService.getNormal('/projects/' + this.inputProject.id),
      (res) => {
        this.inputProject = res;
        if (res.subProjects != null) {
          for (let sub of res.subProjects) {
            if (sub.id === this.subProject.id) {
              this.subProject = sub;
              this.oninitSent = sub.quotationSent;
              this.quotationWasNull = sub.quotation == null;
              if (this.subProject.type === 'BaseProject') {
                this.subProject = <BaseProject>this.subProject;
              }
              break;
            }
          }
        }
        this.initLocationAssets();
        this.init = true;
      }
    );
  }

  setSiteVisit(value) {
    if (this.subProject.projectPlacement != null) {
      this.subProject.projectPlacement.siteVisit = value;
    } else {
      this.subProject.projectPlacement = new ProjectPlacement();
      this.subProject.projectPlacement.siteVisit = value;
    }
  }

  siteVisitExecutedChanged(value) {
    this.subProject.projectPlacement.siteVisitExecuted = value;
  }

  setExtraInfoSiteVisit(value) {
    this.subProject.projectPlacement.extraInfoSiteVisit = value;
  }

  setSiteVisitFeedback(value) {
    this.subProject.projectPlacement.siteVisitFeedback = value;
  }

  chargeChanged(value) {
    this.subProject.projectPlacement.charge = value;
  }

  deadlineSiteVisitChanged(value) {
    this.subProject.projectPlacement.deadlineSiteVisit = value;
  }

  setImportantSiteVisit() {
    if (this.subProject.siteVisitImportant != null) {
      this.subProject.siteVisitImportant = !this.subProject.siteVisitImportant;
    } else {
      this.subProject.siteVisitImportant = true;
    }
  }

  setQuotationComments(value) {
    this.subProject.quotationComments = value;
  }

  setExtraInfoInvoice(value) {
    this.subProject.extraInfoInvoice = value;
  }

  setQuotationApproved(value) {
    this.subProject.quotation.approved = value;
  }

  setQuotationApprovalReasons(value) {
    this.subProject.quotation.approvalReasons = value;
  }

  setNoteForCustomer(value) {
    this.subProject.quotation.noteForCustomer = value;
  }

  setQuotationSent(value) {
    this.subProject.quotationSent = value;
  }

  setQuotationFollowed(value) {
    this.subProject.quotationFollowed = value;
  }

  setIncludeRepoInPrice(value) {
    ProjectHelper.getBaseProject(this.inputProject).includeRepoInPrice = value;
  }

  setDelayed(value) {
    this.subProject.delayed = value;
  }

  setDelayedReason(value) {
    this.subProject.delayedReason = value;
  }

  initQuotations() {
    if (this.subProject.quotation == null) {
      this.subProject.quotation = new Quotation();
    }
  }

  compareEntities(o1, o2) {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      return o1.id === o2.id;
    } else {
      return false;
    }
  }

  formatDate(date) {
    return DateHelper.formatDate(date);
  }

  getSubprojectStatus() {
    return ProjectHelper.getSubProjectTypeTitle(this.subProject);
  }

  getAsBaseProject(): BaseProject {
    return <BaseProject>this.subProject;
  }

  getSendQuotationLabel() {
    return this.subProject.quotation != null &&
      this.subProject.quotationSent &&
      CollectionHelper.isPopulated(this.subProject.quotation.registeredActions)
      ? 'Offerte opnieuw versturen'
      : 'Offerte versturen';
  }

  initLocationAssets() {
    if (this.inputProject != null && this.subProject != null) {
      const fromSubProject =
        this.subProject.type === 'BaseProject'
          ? this.subProject
          : ProjectHelper.getBaseProject(this.inputProject);
      if (fromSubProject != null) {
        this.locationAssets =
          fromSubProject.projectPlacement == null ||
          fromSubProject.projectPlacement.projectPlacementAssets == null
            ? null
            : fromSubProject.projectPlacement.projectPlacementAssets.filter(
                (pa) => !pa.archived && pa.formSection === 'sitePhotos'
              );
      }
    }
  }

  openSendQuotationModal() {
    this.sending = true;
    this.addSubscription(
      this.requestService.put(this.inputProject, '/projects'),
      (res) => {
        if (CollectionHelper.isPopulated(res.subProjects)) {
          const resSubProject = res.subProjects.find(
            (sp) => sp.id === this.subProject.id
          );
          if (
            resSubProject != null &&
            resSubProject.quotation != null &&
            this.subProject.quotation != null
          ) {
            this.subProject.quotation.id = resSubProject.quotation.id;
            if (this.setSubProjectSubject != null) {
              this.setSubProjectSubject.next(resSubProject);
            }
          }
        }
        this.sending = false;
        this.doOpenSendQuotationModal();
      },
      (err) => {
        this.snackService.showError('Kon project niet opslaan: ' + err);
        this.sending = false;
      }
    );
  }

  doOpenSendQuotationModal() {
    let config = {
      project: this.inputProject,
      subProject: this.subProject,
    };
    this.sendQuotationDialogRef = this.sendQuotationDialog.open(
      SendQuotationMailComponent,
      {
        data: config,
      }
    );
    this.addSubscription(
      this.sendQuotationDialogRef.afterClosed(),
      (registeredAction: RegisteredAction) => {
        if (registeredAction != null) {
          const subProject = this.inputProject.subProjects.find(
            (sp) => sp.id === this.subProject.id
          );
          if (subProject.quotation.registeredActions == null) {
            subProject.quotation.registeredActions = [registeredAction];
          } else {
            subProject.quotation.registeredActions.unshift(registeredAction);
          }
          subProject.quotationSent = true;
          if (this.setSubProjectSubject != null) {
            this.setSubProjectSubject.next(subProject);
          }
        }
      }
    );
  }

  openResetQuotationSentModal() {
    const config = {
      subProjectId: this.subProject.id,
      reason: this.subProject.quotationSentResetReason,
    };
    this.resetQuotationSentDialogRef = this.resetSendQuotationDialog.open(
      ResetQuotationSentComponent,
      {
        data: config,
      }
    );
    this.addSubscription(
      this.resetQuotationSentDialogRef.afterClosed(),
      (reason: string) => {
        if (!StringHelper.isEmpty(reason)) {
          this.subProject.quotationSent = false;
          this.subProject.quotationSentResetReason = reason;
          this.subProject.quotationFollowed = false;
          if (this.setSubProjectSubject != null) {
            this.setSubProjectSubject.next(this.subProject);
          }
        }
      }
    );
  }

  resetQuotation() {
    this.modalService.confirmDialog(
      'Nieuwe offerte',
      'Bent u zeker dat er een nieuwe offerte moet worden opgemaakt?',
      (b) => {
        if (b) {
          this.subProject.quotationSent = false;
          this.subProject.quotation.approved = null;
          this.subProject.quotationFollowed = false;
          if (
            this.subProject.quotationHandler != null &&
            this.subProject.quotationHandler.user != null
          ) {
            this.openQuotationResetNotificationModal();
            this.addSubscription(
              this.notificationMailDialogRef.afterClosed(),
              (requestBody) => {
                this.handleNotificationMailRequestBody(requestBody);
              }
            );
          } else {
            this.handleNotificationMailRequestBody();
          }
        }
      }
    );
  }

  openQuotationResetNotificationModal() {
    const config = {
      project: this.inputProject,
      userOptions: [this.subProject.quotationHandler.user],
      subProjectId: this.subProject.id,
      showQuotationAddress: true,
      selectAll: true,
      performSend: false,
    };
    this.notificationMailDialogRef = this.notificationMailDialog.open(
      NotificationMailComponent,
      {
        data: config,
      }
    );
  }

  resetDesign() {
    this.modalService.confirmDialog(
      'Nieuw design',
      'Bent u zeker dat er een nieuw design moet worden opgemaakt?',
      (b) => {
        if (b) {
          const designerMap = new Map<number, User>();
          this.unsetDesignVariables(designerMap);
          if (designerMap.size > 0) {
            this.openResetDesignModal(designerMap);
            this.addSubscription(
              this.notificationMailDialogRef.afterClosed(),
              (requestBody) => {
                this.handleNotificationMailRequestBody(requestBody, true);
              }
            );
          } else {
            this.handleNotificationMailRequestBody(null, true);
          }
        }
      }
    );
  }

  unsetDesignVariables(designerMap: Map<number, User>) {
    if (this.subProject.type === 'BaseProject') {
      this.unsetBaseProjectDesignVariables(designerMap);
    } else {
      this.unsetAdjustmentDesignVariables(designerMap);
    }
  }

  unsetBaseProjectDesignVariables(designerMap: Map<number, User>) {
    if (!CollectionHelper.isPopulated(this.inputProject.products)) {
      return;
    }
    this.inputProject.products.forEach((p) => {
      p.designSentToCustomer = false;
      p.customerApproves = null;
      p.designFinished = null;
      if (p.designer != null && p.designer.user != null) {
        designerMap.set(p.designer.user.id, p.designer.user);
      }
    });
  }

  openResetDesignModal(designerMap: Map<number, User>) {
    let userOptions: User[] = [];
    designerMap.forEach((user: User, id: number) => {
      userOptions.push(user);
    });
    const config = {
      project: this.inputProject,
      userOptions: userOptions,
      subProjectId: this.subProject.id,
      selectAll: true,
      performSend: false,
    };
    this.notificationMailDialogRef = this.notificationMailDialog.open(
      NotificationMailComponent,
      {
        data: config,
      }
    );
  }

  unsetAdjustmentDesignVariables(designerMap: Map<number, User>) {
    const adjustment = <Adjustment>this.subProject;
    adjustment.designSentToCustomer = false;
    adjustment.designApproved = null;
    adjustment.designFinished = null;
    if (
      adjustment.adjustmentDesigner != null &&
      adjustment.adjustmentDesigner.user != null
    ) {
      designerMap.set(
        adjustment.adjustmentDesigner.user.id,
        adjustment.adjustmentDesigner.user
      );
    }
  }

  handleNotificationMailRequestBody(
    requestBody?: NotificationMailRequestBody,
    notifySetProjectSubject = false
  ) {
    requestBody =
      requestBody == null
        ? {
            project: this.inputProject,
            sendEmail: false,
            sendToProjectsAddress: false,
            sendToQuotationAddress: false,
            sendToToonVanbilsen: false,
          }
        : requestBody;
    this.performingResetAction = true;
    this.addSubscription(
      this.requestService.post(
        requestBody,
        `/projects/updateAndSendNotificationEmail/${this.inputProject.id}`
      ),
      (res) => {
        if (res.success) {
          this.inputProject = res.project;
          this.subProject = res.project.subProjects.find(
            (sp) => sp.id === this.subProject.id
          );
          if (!notifySetProjectSubject && this.setSubProjectSubject != null) {
            this.setSubProjectSubject.next(this.subProject);
          } else if (
            notifySetProjectSubject &&
            this.setProjectSubject != null
          ) {
            this.setProjectSubject.next(this.inputProject);
          }
          this.snackService.showSuccess(res.message);
        } else {
          this.snackService.showError(res.message);
        }
        this.performingResetAction = false;
      },
      (err) => {
        this.snackService.showError(err);
        this.performingResetAction = false;
      }
    );
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
